//import mybagjup from './assets/mybagjup.jpeg'; // adjust path if needed
import mybagjup from '../assets/gallery/mybagjup.png'
export const tasks = [
  {
    id: 1,
    description: 'Follow @henrys0x on X',
    points: 10,
    linkText: 'https://x.com/henrys0x',
    linkUrl: 'https://x.com/henrys0x'
  },
  {
    id: 2,
    description: 'Join The X Community',
    points: 20,
    linkText: 'https://x.com/i/communities/1933583099096625391',
    linkUrl: 'https://x.com/i/communities/1933583099096625391'
  },
  {
    id: 3,
    description: 'Retweet our latest post',
    points: 15,
    linkText: 'https://x.com/henrys0x/status/1234567890',
    linkUrl: 'https://x.com/henrys0x/status/1234567890'
  },
  {
    id: 4,
    description: 'Click the like button on JUP – help get $MYBAGS verified',
    points: 25,
    linkText: 'https://jup.ag/tokens/4Yd2z3AEFevY1yXfLLXxKyc3LGUWSQTYJu9QEJembonk',
    linkUrl: 'https://jup.ag/tokens/4Yd2z3AEFevY1yXfLLXxKyc3LGUWSQTYJu9QEJembonk',
    image: mybagjup
  }
];
